import React from 'react';
import { useDispatch } from 'react-redux';
import { openSidePanel, closeSidePanel } from 'Store';

const useSidePanel = () => {
    const dispatch = useDispatch();

    const openImportExportQueue = React.useCallback(() => {
        dispatch(openSidePanel());
    }, [dispatch]);

    const closeImportExportQueue = React.useCallback(() => dispatch(closeSidePanel()), [dispatch]);

    return {
        openImportExportQueue,
        closeImportExportQueue
    };
};

export default useSidePanel;
